/**
 * BGVN Discount % Badges
 * Replaces "Giảm giá" with "Giảm X%" on product cards
 * Runs after DOM is ready + watches for dynamic card loading
 */
(function() {
  'use strict';

  function parsePrice(text) {
    if (!text) return 0;
    // Remove everything except digits
    // "1.100.000 VND" → "1100000" → 1100000
    var cleaned = text.replace(/[^\d]/g, '');
    return parseInt(cleaned, 10) || 0;
  }

  function updateBadges() {
    // Rise theme DOM structure:
    // .card-wrapper
    //   > .card > .card__inner > .card__badge > span.badge  (badge here)
    //   > .card-information-wrapper > .card-information > .price-wrapper
    //     > .price.price--on-sale
    //       > .price__sale
    //         > span.price-item.price-item--regular  (compare-at / strikethrough)
    //         > span.price-item.price-item--sale     (actual sale price)
    //
    // IMPORTANT: .price-item--regular OUTSIDE .price__sale = the current sale price!
    //            .price__sale .price-item--regular = the compare-at (original) price!
    
    var badges = document.querySelectorAll('.badge');
    
    badges.forEach(function(badge) {
      var badgeText = badge.textContent.trim();
      
      // Skip non-sale badges (e.g. "Hết hàng" / sold out)
      if (badgeText.indexOf('Gi') === -1 && 
          badgeText.indexOf('gi') === -1 && 
          badgeText.toLowerCase().indexOf('sale') === -1) return;
      
      // Already processed
      if (badgeText.indexOf('%') !== -1) return;
      
      // Walk up to find the product card container
      var card = badge.closest('.card-wrapper') || 
                 badge.closest('.product-card-wrapper') ||
                 badge.closest('.grid__item') ||
                 badge.closest('li');
      if (!card) return;
      
      // Rise theme specific selectors:
      // The compare-at price (strikethrough) is INSIDE .price__sale container
      var compareEl = card.querySelector('.price__sale .price-item--regular');
      var saleEl = card.querySelector('.price-item--sale');
      
      if (!compareEl || !saleEl) return;
      
      var comparePrice = parsePrice(compareEl.textContent);
      var salePrice = parsePrice(saleEl.textContent);
      
      if (comparePrice <= 0 || salePrice <= 0 || salePrice >= comparePrice) return;
      
      // Calculate discount percentage
      var discountPct = Math.round((1 - salePrice / comparePrice) * 100);
      
      if (discountPct > 0 && discountPct < 100) {
        badge.textContent = '-' + discountPct + '%';
      }
    });
  }

  // Run when DOM is ready
  function init() {
    updateBadges();
    
    // Watch for dynamically loaded cards (AJAX pagination, filtering)
    var observer = new MutationObserver(function(mutations) {
      var shouldUpdate = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          shouldUpdate = true;
          break;
        }
      }
      if (shouldUpdate) {
        clearTimeout(window.__bgvnBadgeTimer);
        window.__bgvnBadgeTimer = setTimeout(updateBadges, 300);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
})();
